import apiFetch from '../apiFetch'

export default function (filtros, token) {
  return apiFetch({endPoint: `AjusteStock`, method: 'POST', body: filtros, token: token})
}
